import request from "@/utils/request";

// 防沉迷链接列表
export function linkListApi(data) {
    return request({
        url: "/admin/anti_addiction",
        method: "get",
        params: data
    });
}


// 防沉迷链接-添加
export function addLinkApi(data) {
  return request({
      url: "/admin/anti_addiction",
      method: "post",
      data
  });
}

// 防沉迷链接-修改(获取)
export function getFixApi(data) {
  return request({
      url: "/admin/anti_addiction/" + data.id,
      method: "get",
      params: data
  });
}

// 防沉迷链接-修改(提交)
export function putFixApi(data) {
  return request({
      url: "/admin/anti_addiction/" + data.id,
      method: "put",
      data
  });
}

// 防沉迷链接-删除
export function deleteLinkApi(data) {
  return request({
      url: "/admin/anti_addiction/" + data.id,
      method: "delete",
      data
  });
}

// 防沉迷链接-查看备注
export function viewRemarkApi(data) {
  return request({
      url: "/admin/show_link_remark/" + data.id,
      method: "get",
      params: data
  });
}

// 防沉迷链接-提交备注
export function putRemarkApi(data) {
  return request({
      url: "/admin/add_link_remark/" + data.id,
      method: "post",
      data
  });
}

// 防沉迷链接-查看历史记录
export function viewHistoryApi(data) {
  return request({
      url: "/admin/show_link_list/" + data.id,
      method: "get",
      params: data
  });
}

// 防沉迷链接-获取下拉框
export function getLinkSelectApi() {
  return request({
      url: "/admin/get_link_select" ,
      method: "get",
  });
}

